import request from '@/config/axios'
export const getPromptWordsPage = (params: any) => request.get({ url: '/ai/prompt-words/page', params })
export const createPromptWords = (data: any) => request.post({ url: '/ai/prompt-words/create', data })
export const updatePromptWords = (data: any) => request.put({ url: '/ai/prompt-words/update', data })
export const deletePromptWords = (id: number) => request.delete({ url: '/ai/prompt-words/delete', params: { id } })
